module.exports = __webpack_public_path__ + "img/burundi.24d0ecf6.svg";